import INDUSTRY_TEMPLATES_JSON from '../shared/industryTemplates.json';

export const INDUSTRY_TEMPLATE_STATUS = Object.freeze({
  ACTIVE: 'active',
  PREVIEW: 'preview',
  DEPRECATED: 'deprecated'
});

export const INDUSTRY_TEMPLATE_APPLY_MODE = Object.freeze({
  FILL_MISSING_ONLY: 'fill_missing_only',
  REPLACE_TERMINOLOGY_AND_MODULES: 'replace_terminology_and_modules'
});

export const INDUSTRY_TEMPLATE_APPLY_MODE_OPTIONS = Object.freeze([
  {
    value: INDUSTRY_TEMPLATE_APPLY_MODE.FILL_MISSING_ONLY,
    label: 'Fill Missing Only'
  },
  {
    value: INDUSTRY_TEMPLATE_APPLY_MODE.REPLACE_TERMINOLOGY_AND_MODULES,
    label: 'Replace Terminology and Modules'
  }
]);

export const INDUSTRY_TEMPLATE_CATALOG = Object.freeze(INDUSTRY_TEMPLATES_JSON);

export function getIndustryTemplateStatusLabel(status) {
  if (status === INDUSTRY_TEMPLATE_STATUS.PREVIEW) return 'Preview';
  if (status === INDUSTRY_TEMPLATE_STATUS.DEPRECATED) return 'Deprecated';
  return 'Active';
}

